<template>
	<div class="login-header">
		<div class="logo-container">
			<!-- <img src="../../assets/top-logo.png" alt=""> -->
			<img class="logo" src="../../assets/logo.png" />
			<div class="line"></div>
			<div class="logo-text">
				Enjoy the Gateway to E-Retail
			</div>
			<!-- <img class="logo-text" src="../../assets/logo-text.png" alt=""> -->
		</div>
		<div class="right-container" flex="cross:center main:center">
			<!-- <div class="lan"> -->
			<el-dropdown @command="handleCommandLang">
				<div class="we-chat" style="float:left;margin-left:20px;color:#666;cursor:pointer;">
					<span class="">{{$t('base.i18n')}}</span>
					<i class="el-icon-arrow-down"></i>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="zh-CN">{{$t('lang.zh')}}</el-dropdown-item>
					<el-dropdown-item command="en-US">{{$t('lang.en')}}</el-dropdown-item>
					<el-dropdown-item command="my">{{$t('lang.my')}}</el-dropdown-item>
					<el-dropdown-item command="pt">{{$t('lang.pt')}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<!-- </div> -->
			<div class="user-info" v-if="page=='platform'">
				<span>{{userInfo.username}}</span>
				<span><a href="#" @click="logout">{{$t('button.signOut')}}</a></span>
			</div>
		</div>
	</div>
</template>

<script>
import { logout } from "@/api"
import { removeToken } from '@/auth'
import i18n from "@/lang";
import { addLangAtHtml } from '@/utils/langFn'
import { setStoreSysLang } from '@/lang/langUtils'

export default {
    name: "head-top",
    data() {
        return {};
    },
    props: {
        page: {
            type: String,
            default: 'login'
        },
        userInfo: {
            type: Object,
            default() {
                return {
                    username: ""
                }
            }
        }
    },
    components: {
    },
    mounted() {
    },
    methods: {
        handleCommandLang(type) {
            setStoreSysLang(type)
            this.$i18n.locale = type;
            addLangAtHtml(type)
            location.reload();
        },
        /**
		 * 跳转官网
		 */
        goOfficialWebsite() {
            window.open('https://egatee.com/')
            // window.location.href = window.HOME_URL || '';
        },
        logout() {
            logout().then(res => {
                removeToken()
                localStorage.removeItem("token")
                localStorage.removeItem("userInfo")
                this.$router.push({ path: '/login' })
                console.log(res)
            })
        },
    }
}
</script>


<style lang="scss" scoped >
::v-deep .el-dropdown {
	font-size: 16px;
	.el-icon-arrow-down {
		margin-left: 5px;
	}
	span {
		font-size: 16px;
	}
	i {
		position: relative;
		top: 1px;
	}
}

.login-header {
	cursor: default;
	height: 40px;
	padding: 24px 0 14px;
	width: 1200px;
	margin: 0px auto;
	border-bottom: 1px solid #fbfbfb;
	display: flex;
	justify-content: space-between;

	.logo-container {
		// width: 440px;
		display: flex;
		align-items: center;

		.line {
			width: 3px;
			height: 26px;
			background-color: #e0dcdd;
			margin: 0 16px;
		}

		.logo {
			// cursor: pointer;
			width: 138px;
			height: 40px;
			// height: 100%;
		}

		.logo-text {
			// cursor: pointer;
			// width: 262px;
			// height: 20px;
			font-size: 20px;
			color: #958c8d;
			line-height: 40px;
		}
	}

	.right-container {
		display: flex;
		// justify-items: center;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		font-family: "ArialMT", "Avenir", Helvetica, Arial, sans-serif;

		.user-info {
			font-size: 18px;
			// display: flex;
			// padding: 20px;
			margin-left: 18px;
			color: #333333;
			text-align: center;
		}

		.user-info span a {
			font-family: Arial-BoldMT;
			color: #4286f4;
			margin-left: 18px;
			text-decoration: none;
			font-weight: bolder;
		}
	}
}
</style>